import { Star } from "lucide-react";

export default function CustomerReviews() {
  return (
    <section className="py-24 bg-gradient-to-br from-white via-blue-50 to-indigo-50 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-80 h-80 bg-gradient-to-br from-blue-200/20 to-indigo-200/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 bg-clip-text text-transparent">
            Loved by Food Enthusiasts
          </h2>
          <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
            Discover why thousands of customers choose our fresh salads every day.
            Real stories from real people who love healthy eating.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-3xl shadow-xl border border-blue-100 hover:border-blue-200 transition-all duration-300 hover:shadow-2xl">
            <div className="flex items-center mb-6">
              <div className="flex bg-amber-50 p-3 rounded-xl border border-amber-200">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-amber-500 fill-current" />
                ))}
              </div>
              <span className="ml-3 text-gray-700 font-semibold">4.9</span>
            </div>
            <p className="text-gray-700 mb-6 text-lg leading-relaxed">
              "The Vegan Muscle Bowl is absolutely delicious! Fresh ingredients,
              perfect portions, and delivered so quickly. My favorite healthy lunch option!"
            </p>
            <div className="flex items-center">
              <img
                src="https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg"
                alt="Customer"
                className="w-14 h-14 rounded-full mr-4 object-cover border-2 border-blue-200"
              />
              <div>
                <div className="font-bold text-gray-800">Darshika Patel</div>
                <div className="text-sm text-blue-600 font-medium">Yoga Enthusiast</div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-xl border border-indigo-100 hover:border-indigo-200 transition-all duration-300 hover:shadow-2xl">
            <div className="flex items-center mb-6">
              <div className="flex bg-amber-50 p-3 rounded-xl border border-amber-200">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-amber-500 fill-current" />
                ))}
              </div>
              <span className="ml-3 text-gray-700 font-semibold">4.6</span>
            </div>
            <p className="text-gray-700 mb-6 text-lg leading-relaxed">
              "Perfect for busy professionals! The Pro-Paneer Protein Power bowl keeps me
              energized throughout the day. Love the fresh, quality ingredients."
            </p>
            <div className="flex items-center">
              <img
                src="https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg"
                alt="Customer"
                className="w-14 h-14 rounded-full mr-4 object-cover border-2 border-indigo-200"
              />
              <div>
                <div className="font-bold text-gray-800">Chirag Desai</div>
                <div className="text-sm text-indigo-600 font-medium">Personal Trainer</div>
              </div>
            </div>
          </div>

          <div className="bg-white p-8 rounded-3xl shadow-xl border border-purple-100 hover:border-purple-200 transition-all duration-300 hover:shadow-2xl">
            <div className="flex items-center mb-6">
              <div className="flex bg-amber-50 p-3 rounded-xl border border-amber-200">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-amber-500 fill-current" />
                ))}
              </div>
              <span className="ml-3 text-gray-700 font-semibold">4.9</span>
            </div>
            <p className="text-gray-700 mb-6 text-lg leading-relaxed">
              "Amazing variety and so colorful! The Rainbow crunch bowl is my favorite -
              it tastes as good as it looks and helps me reach my nutrition goals."
            </p>
            <div className="flex items-center">
              <img
                src="https://images.pexels.com/photos/3184295/pexels-photo-3184295.jpeg"
                alt="Customer"
                className="w-14 h-14 rounded-full mr-4 object-cover border-2 border-purple-200"
              />
              <div>
                <div className="font-bold text-gray-800">Bhavika Limbachiya</div>
                <div className="text-sm text-purple-600 font-medium">Beautician</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
